import { deleteConsignorData } from '_services/accountsServices/consignorServices';
import { changeUnitStatusData, deleteUnitData, getUnitListData } from '_services/accountsServices/unitServices';
import { ButtonHeading, CommonModal, CustomPagination, NavTabs } from 'components'
import { AddEditUnitModal, AddUnitModal } from 'modals';
import React, { useContext, useEffect, useRef, useState } from 'react'
import toast from 'react-hot-toast';
import { Link, useNavigate, useParams } from 'react-router-dom';
import StorageService from 'utils/StorageServices/StorageServices';
import BootstrapTable from 'components/BootstrapTable';
import { BsThreeDotsVertical } from "react-icons/bs";
import { AiOutlineEye } from "react-icons/ai";
import { FiEdit } from "react-icons/fi";
import { FaRegTrashCan } from "react-icons/fa6";
import { IoChevronBack, IoChevronForward } from "react-icons/io5";
import MastersFilterModal from 'modals/MastersFilterModal';
import LoadingBar from 'react-top-loading-bar';
import { deleteAddressBook, updateStatusAddressBookApi } from '_services/accountsServices/addressBookService';
import { UserContext } from 'context';
import useDocumentTitle from 'hooks/useDocumentTitle';
import CustomTooltip from 'components/CustomTooltip/CustomTooltip';
import { constant } from 'constants/constant';
import './unit.css';

const Unit = (props) => {
  useDocumentTitle("Unit | T360");

  let { handleScrollClass = '', isConsignor = '', isFilterButton = true, firmId } = props;
  const navigate = useNavigate();
  let { id } = useParams();
  const { mastersChild, setMasterDetailsList } = useContext(UserContext);
  const masterChildUnit = mastersChild?.find((i) => i?.label === "Unit");

  const loadingBarRef = useRef(null);
  const [showOffcanvas, setShowOffcanvas] = useState(false);
  const [showFilterModal, setShowFilterModal] = useState(false);
  const [unitList, setUnitList] = useState([])
  const [loading, setLoading] = useState(false);
  const [isDelete, setIsDelete] = useState(false);

  const prevFilterRef = useRef();
  const itemsPerPage = 25;
  const [totalItems, setTotalItems] = useState(0);
  const [filter, setFilter] = useState({
    limit: 25,
    offset: 1,
    search: '',
    status: 1
  });

  const [editUnitData, setEditUnitData] = useState(null)
  const [checkboxStates, setCheckboxStates] = useState({});
  const [addressId, setAddressId] = useState({
    id: "",
    title: "Unit",
    view: false
  })

  const toggleOffcanvas = () => {
    setShowOffcanvas(!showOffcanvas);
    setEditUnitData(null)
  };

  const getDataUnitList = async () => {
    try {
      if (loadingBarRef.current) {
        loadingBarRef.current.continuousStart(); // Start the loading bar
      }
      let object = {
        ...filter,
        consignor_id: isConsignor,
        company_id: StorageService.getCompanyId(),
        firm_id: firmId?._id ? firmId?._id : StorageService.getFirmId(),
      }
      const res = await getUnitListData(object);
      if (res?.responseCode == 200) {
        setUnitList(res?.data?.unit_list);
        setTotalItems(res?.data?.total_record);
      }
    } catch (error) {
      // throw error;
    } finally {
      if (loadingBarRef.current) {
        loadingBarRef.current.complete(); // Complete the loading bar
      }
    }
  }

  useEffect(() => {
    const prevFilter = prevFilterRef.current;
    if (JSON.stringify(prevFilter) !== JSON.stringify(filter) && !id) {
      getDataUnitList();
      prevFilterRef.current = filter;
    }
  }, [filter, showOffcanvas])

  useEffect(() => {
    if (id) {
      getDataUnitList();
    }
  }, [id, filter?.search])

  // useEffect(() => {
  //   setMasterDetailsList({})
  // }, [])

  const deleteHandler = (item) => {
    setIsDelete(item)
  }

  const submitDeleteConsignor = async () => {
    setLoading(true);
    try {
      let object = {
        company_id: isDelete?.company_id,
        addressbook_id: isDelete?._id,
      }
      const res = await deleteAddressBook(object);
      if (res?.responseCode == 200) {
        toast.success(`${res?.responseMessage}`);
        getDataUnitList();
        setLoading(false);
        setIsDelete(false);
      } else {
        toast.success('Error !! ');
        setLoading(false);
      }
    } catch (error) {
      setLoading(false);
      // throw error;
    }
  }

  let propsObject = {
    isOpen: isDelete,
    closeModal: setIsDelete,
    modalTitle: "Confirmation",
    submitTitle: "Confirm",
    cancleTitle: "Close",
    onSubmit: submitDeleteConsignor,
    isLoadding: loading,
  }

  const columns = [
    // { header: "", accessor: "serial" },
    { header: "Unit Code", accessor: "code" },
    { header: "Unit Name", accessor: "unit_name" },
    { header: "Firm", accessor: "firm_id" },
    { header: "Associate Party", accessor: "associate_party" },
    { header: "City", accessor: "city" },
    { header: "Branch", accessor: "branch" },
    { header: "Zone", accessor: "zone" },
    { header: "Status", accessor: "status" },
    { header: "Action", accessor: "action" },
  ];

  useEffect(() => {
    if (unitList && unitList.length > 0) {
      // Initialize checkboxStates based on data
      const initialStates = unitList.reduce((acc, item) => {
        acc[item._id] = Boolean(item?.active);
        return acc;
      }, {});
      setCheckboxStates(initialStates);
    }
  }, [unitList]);

  const handleCheckboxChange = (id, index) => {
    const newStatus = !id?.active;

    const list = [...unitList];

    list[index].active = newStatus;

    setUnitList(list);

    const object = {
      company_id: StorageService.getCompanyId(),
      addressbook_id: id?._id,
      active: Number(newStatus),
    };
    statusChangeofUnit(object);
  };


  const statusChangeofUnit = async (obj) => {
    try {
      if (obj) {
        const res = await updateStatusAddressBookApi(obj)
        if (res?.responseCode == 200) {
          toast.success(`${res?.responseMessage}`);
          await getDataUnitList();
        } else {
          toast.error('Error !!');
          await getDataUnitList();
        }
      }
    } catch (error) {
      toast.error(error.message);
      await getDataUnitList();
    }
  };

  const editHandler = (supplier) => {
    setShowOffcanvas(true);
    setEditUnitData(supplier);
    setAddressId({
      ...supplier,
      id: supplier?._id
    })
  };

  const getAssociatedPartyNames = (associatePartyArray) => {
    return associatePartyArray?.map(party => party.name).join(" | ") || "";
  };

  const handleClick = (event) => {
    event.stopPropagation();
  };

  const onRowClick = (e, item) => {
    navigate(`/account/unit/details/${item?._id}?type=${constant.m_type.unit}&tab=${1}&search=${filter?.search}&offset=${+filter?.offset}&total_record=${totalItems}`)
    setMasterDetailsList((s) => ({ ...s, list: unitList, details: item }))
  }

  const RowListData = (data) => {

    return data?.map((item, i) => ({
      ...item,
      // serial: <>{i + 1 + filter?.limit * (filter?.page - 1)}</>,
      serial: <>
        <div className="signDropdown">
          <button className="dropbtn11">
            <BsThreeDotsVertical />
          </button>
          <div className="dropdownContent">
            {masterChildUnit?.view === 1 &&
              <Link to={`/account/unit/details/${item?._id}`}
                className='_avPointer'
                style={{ textDecoration: 'none' }}
              >
                <span className='_samAnchor'>
                  <span className='viewIcon_avt'>
                    <AiOutlineEye />
                  </span>View
                </span>
              </Link>
            }
            {masterChildUnit?.edit === 1 &&
              <div
                onClick={(e) => editHandler(item)}
                className='_avPointer'
              >
                <span className='_samAnchor'>
                  <span className='editIcon_avt'>
                    <FiEdit />
                  </span>
                  Edit
                </span>
              </div>
            }
            {masterChildUnit?.delete === 1 &&
              <div
                onClick={(e) => deleteHandler(item)}
                className='_avPointer'
              >
                <span className='_samAnchor'>
                  <span className='deleteIcon_avt'>
                    <FaRegTrashCan color='red' />
                  </span>
                  Delete
                </span>
              </div>
            }
          </div>
        </div>

      </>,
      unit_name:
        <>
          {item?.name && item.name.length > 20 ? (
            <CustomTooltip txtClass="__tooltipTxt_bx">
              <Link
                to={`/account/unit/details/${item?._id}?type=${constant.m_type.unit}&tab=1&search=${filter?.search}&offset=${+filter?.offset}&total_record=${totalItems}`}
                style={{ textDecoration: "none" }}
                onClick={(e) => {
                  handleClick(e);
                  setMasterDetailsList((s) => ({
                    ...s,
                    list: unitList,
                    details: item,
                  }))
                }}
              >
                {item.name}
              </Link>
            </CustomTooltip>
          ) : (
            <Link
              to={`/account/unit/details/${item?._id}?type=${constant.m_type.unit}&tab=1&search=${filter?.search}&offset=${+filter?.offset}&total_record=${totalItems}`}
              style={{ textDecoration: "none" }}
              onClick={(e) => {
                handleClick(e);
                setMasterDetailsList((s) => ({
                  ...s,
                  list: unitList,
                  details: item,
                }))
              }}
              className="__NottooltipTxt"
            >
              {item?.name || "-"}
            </Link>
          )}
        </>,
      // <CustomTooltip txtClass='__tooltipTxt_bx'>
      //   <Link to={`details/${item?._id}?type=${constant.m_type.unit}&tab=${1}&search=${filter?.search}&offset=${+filter?.offset}&total_record=${totalItems}`} style={{ textDecoration: 'none' }} onClick={() => setMasterDetailsList((s) => ({ ...s, list: unitList, details: item }))}>
      //     {item?.name ? item?.name : '-'}
      //   </Link>
      // </CustomTooltip>,
      firm_id: <React.Fragment>
        {item?.firm_id?.firm ? item?.firm_id?.firm : '-'}
      </React.Fragment>,
      unit_code:
        <React.Fragment>
          {item?.unit_code ? item?.unit_code : '-'}
        </React.Fragment>,
      unit_group:
        <React.Fragment>
          {item?.unit_group?.name ? item?.unit_group?.name : '-'}
        </React.Fragment>,
      city:
        <React.Fragment>
          {item?.city?.label ? item?.city?.label : '-'}
        </React.Fragment>,
      zone:
        <React.Fragment>
          <CustomTooltip txtClass='__tooltipTxt_bx'>
            <p>{item?.zone_id?.name ? item?.zone_id?.name : '-'}</p>
          </CustomTooltip>
        </React.Fragment>,
      branch:
        <React.Fragment>
          {item?.branch_id?.branch ? item?.branch_id?.branch : '-'}
        </React.Fragment>,
      status: (
        <div className="_anvSwitcherNew form-check form-switch" style={{ width: "125px" }} onClick={(e) => handleClick(e)}>
          <input
            className="form-check-input"
            type="checkbox"
            name="actStatus"
            id={`actStatus-${item._id}`}
            autoComplete="off"
            checked={checkboxStates[item._id]}
            onChange={() => handleCheckboxChange(item, i)}
          />
          <span className={checkboxStates[item._id] ? "active_label_masters_status" : "disabled_label_masters_status"}>
            {checkboxStates[item._id] ? "Active" : "Disabled"}
          </span>
        </div>
      ),
      balance:
        <React.Fragment>
          {item?.balance ? item?.balance : '-'}
        </React.Fragment>,
      action: (
        <React.Fragment>
          -
        </React.Fragment>
      ),
      associate_party: (
        <React.Fragment>
          {(() => {
            const value = String(
              getAssociatedPartyNames(item?.associate_party_id) || ""
            );

            return value.length > 20 ? (
              <CustomTooltip
                txtClass="__tooltipTxt_bx"
                cstStyle={{ maxWidth: "138px" }}
              >
                <p style={{ marginBottom: 0 }}>{value}</p>
              </CustomTooltip>
            ) : (
              <div className="__NottooltipTxt">
                <p style={{ marginBottom: 0 }}>{value || "-"}</p>
              </div>
            );
          })()}
        </React.Fragment>
      ),
      action: (
        <div
          className="_anvSwitcherNew form-check form-switch"
          style={{ width: "100px" }}
        >
          {masterChildUnit?.view === 1 &&
            <Link
              to={`/account/unit/details/${item?._id}?type=${constant.m_type.unit}&tab=${1}&search=${filter?.search}&offset=${+filter?.offset}&total_record=${totalItems}`}
              className='_avPointer'
              style={{ textDecoration: 'none' }}
              onClick={(e) => { handleClick(e); setMasterDetailsList((s) => ({ ...s, list: unitList, details: item })) }}
            >
              <span className='_samAnchor'>
                <span className='viewIcon_avt'>
                  <AiOutlineEye color='green' />
                </span>
              </span>
            </Link>
          }
          {masterChildUnit?.edit === 1 &&
            <div
              onClick={(e) => { handleClick(e); editHandler(item) }}
              className='_avPointer'
            >
              <span className='_samAnchor'>
                <span className='editIcon_avt'>
                  <FiEdit color='blue' />
                </span>

              </span>
            </div>
          }
          {masterChildUnit?.delete === 1 &&
            <div
              onClick={(e) => { handleClick(e); deleteHandler(item) }}
              className='_avPointer'
            >
              <span className='_samAnchor'>
                <span className='deleteIcon_avt'>
                  <FaRegTrashCan color='red' />
                </span>
              </span>
            </div>
          }
        </div>)
    }));
  };

  const handlePageChange = (page) => {
    setFilter((s) => ({ ...s, offset: page }))
  };

  const callBackAddressData = (data) => {
    getDataUnitList()
  }


  return (
    <>
      <LoadingBar
        color="#ffa800"
        ref={loadingBarRef}
        height={4}
        shadow={true}
        loaderSpeed={1000}
      />

      <div className='__unitMainBxs'>
        <ButtonHeading
          title={"Unit"}
          onClick={toggleOffcanvas}
          buttonTitle={masterChildUnit?.create === 1 && "Add Unit"}
          showSearchFilter={{ search: true, filterOption: false, filterCount: true }} // filterOption : (isFilterButton ? true : false)
          onClickFilterModal={(e) => setShowFilterModal(!showFilterModal)}
          filter={filter}
          setFilter={setFilter}
          isDebouncedSearch={true}
          listDownload={true}
          className="commonHeading_title"
        />

        <div className={`_tabWith_outTab ${handleScrollClass}`}>
          <BootstrapTable
            tableClass="masterTable_avt"
            columns={columns}
            data={RowListData(unitList?.length > 0 ? unitList : [])}
            isLoading={loading}
            onRowClick={(e, row) => {
              if (e.target.closest(".no-row-click")) return; // ignore protected cells
              onRowClick(e, row);
            }}
          />

          {unitList?.length > 0 ? <div className='paginationFt_avt'>
            <CustomPagination
              totalItems={totalItems}
              itemsPerPage={itemsPerPage}
              currentPage={filter.offset}
              onPageChange={handlePageChange}
            />
          </div> : <></>}
        </div>
      </div>

      {/* <div
        className={`offcanvas offcanvas-end common_offCanvas ${showOffcanvas ? 'show' : ''}`}
        tabIndex={-1}
        style={{ visibility: showOffcanvas ? 'visible' : 'hidden' }}
      >
        {showOffcanvas &&
          <AddEditUnitModal isOpen={showOffcanvas} onClose={(e) => setShowOffcanvas(false)} />
        }
      </div>
      <div className={showOffcanvas ? 'offBack_drop' : ''}></div> */}

      <div>
        <div
          className={`offcanvas offcanvas-end common_offCanvas ${showOffcanvas ? "show" : ""
            }`}
          tabIndex={-1}
          style={{ visibility: showOffcanvas ? "visible" : "hidden" }}
        >
          {showOffcanvas && (
            <AddUnitModal
              isOpen={showOffcanvas}
              onClose={(e) => {
                setAddressId({ id: "", title: "Unit", view: false })
                setShowOffcanvas(false)
              }}
              id={addressId}
              isConsignor={isConsignor}
              callBackAddressData={callBackAddressData}
              firmId={firmId}
            />
          )}
        </div>
        <div className={showOffcanvas ? "offBack_drop" : ""}></div>
      </div>

      <div
        className={`offcanvas offcanvas-end common_offCanvas ${showFilterModal ? 'show' : ''}`}
        tabIndex={-1}
        style={{ visibility: showFilterModal ? 'visible' : 'hidden' }}
      >
        {showFilterModal &&
          <MastersFilterModal
            isOpen={showFilterModal}
            onClose={() => setShowFilterModal(false)}
            filter={filter}
            setFilter={setFilter}
          />
        }
      </div>
      <div className={showFilterModal ? 'offBack_drop' : ''}></div>

      {
        isDelete?.company_id && (
          <CommonModal {...propsObject}>
            <p className='p-3'> Are you sure, you want to delete {isDelete?.name} ? </p>
          </CommonModal>
        )
      }
    </>
  )
}

export default React.memo(Unit)